import {store} from '../../store/store';
import timeSheetReducer, {clearData, setData} from './slice';
import {TimeSheetItem} from './types';

export const setTimesheetData = (data: Array<TimeSheetItem>) => {
    store.dispatch(setData(data))
}

export const clearTimesheetData = () => {
    store.dispatch(clearData())
}

export { timeSheetReducer };
